(() => {
  const schemaScript = document.querySelector(
    'script[data-professional-faq-schema]'
  );

  if (!schemaScript) return;

  let initialSchema;
  try {
    initialSchema = JSON.parse(schemaScript.textContent);
  } catch (error) {
    console.error('Unable to parse professional FAQ JSON-LD.', error);
    return;
  }

  if (
    !Array.isArray(initialSchema.mainEntity) ||
    initialSchema.mainEntity.some((question) => typeof question.name !== 'string')
  ) {
    console.error('Professional FAQ JSON-LD has invalid question names.');
    return;
  }

  const sourceQuestionNames = initialSchema.mainEntity.map(
    (question) => question.name
  );

  const translateSchemaQuestions = async (language) => {
    if (!window.Weglot || typeof Weglot.translate !== 'function') {
      console.error('Weglot translation API is unavailable for FAQ schema.');
      return;
    }

    const schema = JSON.parse(schemaScript.textContent);
    const questions = schema.mainEntity;

    try {
      const translatedQuestions =
        language === 'en'
          ? sourceQuestionNames
          : await Weglot.translate({
              words: sourceQuestionNames.map((name) => ({ t: 1, w: name })),
              languageTo: language,
            });

      if (
        !Array.isArray(translatedQuestions) ||
        translatedQuestions.length !== questions.length ||
        translatedQuestions.some((question) => typeof question !== 'string')
      ) {
        console.error('Weglot returned an invalid professional FAQ translation.');
        return;
      }

      if (Weglot.getCurrentLang() !== language) return;

      questions.forEach((question, index) => {
        question.name = translatedQuestions[index];
      });
      schemaScript.textContent = JSON.stringify(schema);
    } catch (error) {
      console.error('Unable to translate professional FAQ JSON-LD.', error);
    }
  };

  const updateCurrentLanguage = () => {
    if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
      translateSchemaQuestions(Weglot.getCurrentLang());
    }
  };

  if (window.Weglot && typeof Weglot.on === 'function') {
    Weglot.on('languageChanged', updateCurrentLanguage);
  }

  new MutationObserver(updateCurrentLanguage).observe(
    document.documentElement,
    { attributes: true, attributeFilter: ['lang'] }
  );

  updateCurrentLanguage();
})();
